// A lazy logo must finish before HTML is captured; otherwise a valid Cloud
// logo would silently disappear from the generated PDF.
export const waitForCloudDocumentAssets = async (element: HTMLElement) => {
  if (element.querySelector('[data-cloud-loading="true"]')) await new Promise<void>((resolve, reject) => {
    const timer = setTimeout(() => { observer.disconnect(); reject(new Error('โหลดไฟล์ Cloud สำหรับ PDF นานเกินไป กรุณาลองใหม่')); }, 32_000);
    const observer = new MutationObserver(() => {
      if (element.querySelector('[data-cloud-loading="true"]')) return;
      clearTimeout(timer); observer.disconnect(); resolve();
    });
    observer.observe(element, { subtree: true, attributes: true, childList: true });
  });
  const error = element.querySelector('[data-cloud-error]')?.getAttribute('data-cloud-error');
  if (error) throw new Error(error);
};
